import React, { useState, useEffect } from 'react'
import { styled } from 'styled-components'
import {
	getMap,
	getMapInfo,
	useJuniorPlusStateSelector,
	useResolvers,
} from '../../../context'
import Map from './MapMaker/Map'
import { BACKGROUND_VIDEO_URL } from '../../../assets/constants'

export default function MapScreen(): React$Node {
	const [showMapIntro, setShowMapIntro] = useState(true)

	useEffect(() => {
		// wait 5 seconds to show the map
		const timeoutId = setTimeout(() => setShowMapIntro(false), 5000)
		return () => clearTimeout(timeoutId)
	}, [])

	const map = useJuniorPlusStateSelector(getMap)
	const allObjectInfo = useJuniorPlusStateSelector(getMapInfo)
	const { imageSourceResolver } = useResolvers()
	return (
		<Wrapper>
			<VideoBackground autoPlay muted={true} looping="true">
				<source src={BACKGROUND_VIDEO_URL} />
			</VideoBackground>

			{showMapIntro && (
				<MapIntroDiv>Now displaying surrounding area...</MapIntroDiv>
			)}
			<Map
				style={showMapIntro ? { display: 'none' } : {}}
				missionMap={map}
				objectInfoMap={allObjectInfo}
				imageSourceResolver={imageSourceResolver}
			/>
		</Wrapper>
	)
}

const Wrapper = styled.div`
	position: relative;
	height: 100%;
	width: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
`

const VideoBackground = styled.video`
	height: 100%;
	width: 100%;
	position: absolute;
`

const MapIntroDiv = styled.div.attrs({ className: 'font-game-headline' })`
	height: 65%;
	width: 60%;
	z-index: ${({ theme }) => theme.zVisible};

	padding: ${({ theme }) => theme.spacing2x};
	border-radius: 4px;

	display: flex;
	justify-content: center;
	align-items: center;
	text-align: center;

	color: white;
	background-color: rgba(18, 22, 61, 0.75);
	font-size: ${({ theme }) => theme.fontxxl};
`
